import Vue from 'vue'
import VueRouter from 'vue-router'
import Privacy from '@/views/privacy'
import History from '@/views/history'
import ThirdList from '@/views/thirdList'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/privacy'
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
  },
  {
    path: '/history/:version?',
    name: 'History',
    component: History,
  },
  {
    path: '/third',
    name: 'ThirdList',
    component: ThirdList,
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach(async (to, from, next) => {
  document.title = to?.meta?.title || ''
  next()
})

export default router
